import {Switch} from "@headlessui/react";
import * as React from "react";
import {Controller} from "react-hook-form";
import {useTranslation} from "react-i18next";

export const ControlledSwitch = (props) => {
    const {
        control,
        getValues,
        setValue,
        name,
        translationIndex = '',
        errors,
        disabled = false
    } = props;

    const {t} = useTranslation();

    return (
        <>
            <div className={'flex flex-row'}>
                <Controller
                    control={control}
                    defaultValue={false}
                    name={name}
                    rules={{required: true}}
                    render={({field: {ref, ...rest}}) => (
                        <Switch
                            {...rest}
                            checked={getValues(name)}
                            disabled={disabled}
                            onChange={() => {
                                if (disabled) return;
                                setValue(name, !getValues(name))
                            }}
                            value={getValues(name)}
                            className={`${
                                getValues(name) ? 'bg-primary' : 'bg-gray-200'
                            } ${disabled ? 'opacity-50 cursor-not-allowed' : ''} relative inline-flex h-6 w-11 items-center rounded-full`}
                        >
                            <span className="sr-only">{t(translationIndex)}</span>
                            <span
                                className={`${getValues(name) ? 'translate-x-6' : 'translate-x-1'} inline-block h-4 w-4 transform rounded-full bg-white transition`}
                            />
                        </Switch>
                    )}
                />

                <p className="pl-2">{t(translationIndex)}</p>

            </div>

            {errors[name] !== undefined && errors[name] !== null && <p className={'text-red-500'}>{errors[name].message}</p>}
        </>

    )
}